import { IFIReportTypeItem } from './IFIReportTypeItem'

export const DailyInspectionInspection = new IFIReportTypeItem({
  id: 'c56d9129-3ba6-4c2b-9b6c-52ed57c6f0f7',
  classType: 'DailyInspectionInspection',
  label: 'inspectionId',
  type: 'Inspection',
  importRules: [
    'The inspection must not be deleted',
    'Unresolved Issues Associated with this Work must be set to Yes',
    'The New issue must be enabled',
  ],
  defaultMessages: {
    missing: 'Missing Geometry',
  } as const,
})

export const DailyInspectionControlPoint = new IFIReportTypeItem({
  id: 'a1cc698f-9fb4-4f73-96c2-4a0f1af72e67',
  classType: 'DailyInspectionControlPoint',
  label: 'controlPointId',
  type: 'Control Point',
  importRules: [
    'The inspection must not be deleted',
    'Unresolved Issues Associated with this Work must be set to Yes',
    'The New issue must be enabled',
  ],
  defaultMessages: {
    missing: 'Missing Geometry',
  } as const,
})

export const DailyInspectionPunchList = new IFIReportTypeItem({
  id: '2f915ef5-4e44-4893-b478-d0e7ef225dbc',
  classType: 'DailyInspectionPunchList',
  label: 'punchListId',
  type: 'Punch List',
  importRules: ['The inspection must not be deleted'],
})

export const ConcreteTest = new IFIReportTypeItem({
  id: '33ebe872-4039-40eb-9b7d-330e44d6e6b9',
  classType: 'ConcreteTest',
  label: 'fieldNumber',
  type: 'Concrete Test',
  importRules: [
    'The test must not be deleted',
    'The test set must not be deleted',
    'The test must fail the percent air check, slump check, or temperature check',
  ],
  defaultMessages: {
    ambient: 'Air Temp below Minimum Ambient Air Temperature',
    highTemp: 'High Temperature',
    lowTemp: 'Low Temperature',
    noTemp: 'No Temperature',
    highSlump: 'High Slump',
    lowSlump: 'Low Slump',
    noSlump: 'No Slump',
    highAir: 'High Percent Air',
    lowAir: 'Low Percent Air',
    noAir: 'No Percent Air',
  } as const,
})

export const Lot = new IFIReportTypeItem({
  id: 'db13c15d-9b53-4893-a69e-8c35887b96c6',
  classType: 'Lot',
  label: 'lotId',
  type: 'Density Lot',
  defaultMessages: {
    count: 'Lot did not contain minimum required number of tests',
    proctor: 'Lot was closed without a Global Proctor Value',
    lotCompaction: 'Lot compaction did not exceed material percent compaction',
    testCompaction:
      'Test compaction did not exceed material percent compaction',
  } as const,
})

export const AsphaltLot = new IFIReportTypeItem({
  id: '0d0f32c0-e423-46c5-a3a9-10a2be0768fc',
  classType: 'AsphaltLot',
  label: 'asphaltLotId',
  type: 'Asphalt Lot',
})

export const DensityTest = new IFIReportTypeItem({
  id: '188fdaad-6924-43cf-bfc5-d716ac18f2db',
  classType: 'DensityTest',
  label: 'testId',
  type: 'Density Test',
  defaultMessages: {
    message: 'Test compaction did not exceed material percent compaction',
  } as const,
})
